module.exports = __webpack_public_path__ + "img/Spray.487c899f.svg";